import { IconBlockquote } from '@tabler/icons-react'
import { Rule } from 'antd/lib/form'

import { RichTextCaptureBlock as RenderRichTextCaptureBlock } from '../../templateRenderer/CaptureBlocks/RichTextCaptureBlock'
import { DisplayBlock, RichTextCaptureBlock } from '../../types/blueprint'

import {
  BaseBlockConfig,
  Field,
  FORBIDDEN_IN_APP,
  TypeOption,
} from './_BaseBlockConfig'

import { RichTextInput } from '@/components/form-components/RichTextInput'
import { convertRichBlocksToText } from '@/utils/convertHtmlToText'

class Config extends BaseBlockConfig<RichTextCaptureBlock> {
  public override kind = 'capture' as const
  public override type = 'richText' as const

  public override enableBlockToCsvColumn = true

  public override blockTypeConfig: TypeOption = {
    kind: this.kind,
    value: this.type,
    label: 'Formatted text',
    icon: IconBlockquote,
    helpText:
      'Text input with formatting such as bold, italic, and bullet points',
    forbiddenTemplateTypes: FORBIDDEN_IN_APP,
  }

  public override blockFieldsConfig: Field[] = [
    {
      name: 'value',
      label: 'Default value',
      helpText: 'Used to provide a default value in the input',
      field: { component: RichTextInput },
    },
  ]

  public override mapFormValueToBlock(
    block: RichTextCaptureBlock,
    value: string,
    returnDefaultValue?: boolean
  ): RichTextCaptureBlock {
    if (returnDefaultValue) {
      return block
    }

    return { ...block, value }
  }

  public override mapBlockToDisplayBlock(
    block: RichTextCaptureBlock
  ): DisplayBlock {
    const { value, ...restOfBlock } = block
    return {
      ...restOfBlock,
      content: value ?? '',
      kind: 'display',
    }
  }

  public override mapBlockToCsvValue(
    block: RichTextCaptureBlock
  ): string | null {
    return convertRichBlocksToText([block])
  }

  public override renderBlock(
    block: RichTextCaptureBlock,
    rules?: Rule[]
  ): React.ReactNode {
    return <RenderRichTextCaptureBlock block={block} rules={rules} />
  }
}

export const RichTextCaptureBlockConfig = new Config()
